import {api} from './utils/api';

export const useHubspotMutations = () => {
    const {mutateAsync: createHubspotDeal} = api.deal.createHubspotProsperDeal.useMutation();
    const {mutateAsync: updateHubspotProsperDealGetDecision} =
        api.deal.updateHubspotProsperDealGetDecision.useMutation();
    const {mutateAsync: updateCaseIdHubspotDeal} = api.deal.updateCaseIdHubspotDeal.useMutation();
    const {mutateAsync: updatePolicyNumberHubspotDeal} = api.deal.updateHubspotProsperDealPolicyNumber.useMutation();
    const {mutateAsync: updateHubspotProsperDigitalAppStage} =
        api.deal.updateHubspotProsperDigitalAppStage.useMutation();

    return {
        createHubspotDeal,
        updateHubspotProsperDealGetDecision,
        updateCaseIdHubspotDeal,
        updatePolicyNumberHubspotDeal,
        updateHubspotProsperDigitalAppStage,
    };
};
